import * as React from 'react';
import classNames from 'classnames';

import { Grid } from '@material-ui/core';

import * as EditIcon from '../../../../assets/image/edit2.png';
import * as DeleteIcon from '../../../../assets/image/discard.png';

import existSubscriptionPeriod from '../../utils/existSubscriptionPeriod';

import SubTooltip from '../Tooltip/SubTooltip';
import ExistSubEdit from './ExistSubEdit';

import './styles/mixin.scss';

import ProductPackage from '../../interfaces/ProductPackage';
import * as ExistSubscriptionInterface from '../../interfaces/ExistSubscription';

interface Props {
  sub: ExistSubscriptionInterface.default;
  subscription: ProductPackage;
  canceled?: boolean;
  id: number;
  dateStart: Date;
  dateFinish: Date;
  editExistSubDatetimeFinishValue: Date;
  editExistSubDatetimeFinish: (id: number) => void;
  editExistSubscription: (id: number) => void;
  deleteExistSubscription: (id: number) => void;
  editExistSubId: (id: number) => void;
}

function ExistSubscription (props: Props) {

  const [isEditing, setIsEditing] = React.useState(false);

  const handleDeleteExistSubscription = React.useCallback(() => {
    props.deleteExistSubscription(props.id);
  }, [props.deleteExistSubscription, props.id]);

  const handleOpenEditMenu = React.useCallback(() => {
    props.editExistSubId(props.id);
    setIsEditing(true);
  }, [props.editExistSubId, props.id]);

  const handleDiscardEditMenu = React.useCallback(() => {
    props.editExistSubId(props.id);
    setIsEditing(false);
  }, [props.editExistSubId, props.id]);

  const handleSaveEditMenu = React.useCallback(() => {
    props.editExistSubscription(props.id);
    setIsEditing(false);
  }, [props.editExistSubscription, props.id]);
  
  const {
    subscription,
    id,
    canceled,
    editExistSubDatetimeFinishValue,
    editExistSubDatetimeFinish,
    dateStart,
    dateFinish,
  } = props;

  const subExistFormImage = React.useMemo(() => classNames('sub-exist-form-image', {
    'sub-exist-form-image-disabled': isEditing,
    'cursor-pointer': !canceled,
    'cursor-none': canceled,
  }), [isEditing, canceled]);

  const subExistFormImageEdit = React.useMemo(() => classNames('sub-exist-form-image sub-exist-form-image-edit cursor-pointer', {
    'sub-exist-form-image-disabled': isEditing,
  }), [isEditing]);

  const existSubscriptionClassNames = React.useMemo(() => classNames('exist-subscription', {
    'exist-subscription-editing': isEditing,
    'exist-subscription-canceled': canceled,
    'cursor-pointer': !canceled,
    'cursor-none': canceled,
  }), [isEditing, canceled]);

  const existSubscriptionId = React.useMemo(() => classNames({
    'exist-subscription-id': !canceled,
    'exist-subscription-id-canceled': canceled,
  }), [canceled]);

  return (
    <div className={existSubscriptionClassNames}>
      {subscription ? (
        <Grid container>
          <Grid
            item
            lg={2}
            md={2}
            sm={2}
          >
            <div className={existSubscriptionId}>
              {id}
            </div>
          </Grid>
          <Grid
            item
            lg={7}
            md={7}
            sm={7}
          >
            <div className='exist-subscription-title'>
              {`${subscription.product.name} - ${subscription.name}`}
            </div>
            <div>
              {existSubscriptionPeriod(dateStart, dateFinish)}
            </div>
          </Grid>
          <Grid
            item
            lg={3}>
            <Grid container>
              <Grid
                item
                lg={4}
                md={2}
                sm={2}
              />
              <Grid
                item
                lg={4}
                md={5}
                sm={5}
              >
                <button
                  onClick={handleOpenEditMenu}
                  className='sub-clear-btn'
                >
                  <SubTooltip
                    title='Edit'
                    wrappedNode={
                      <img
                        className={subExistFormImageEdit}
                        src={EditIcon}
                        alt='' />
                    } />
                </button>
              </Grid>
              <Grid
                item
                lg={4}
                md={5}
                sm={5}
              >
                <button
                  onClick={handleDeleteExistSubscription}
                  className='sub-clear-btn'
                >
                  <SubTooltip
                    title='Close'
                    wrappedNode={
                      <img
                        className={subExistFormImage}
                        src={DeleteIcon}
                        alt='' />
                    } />
                </button>
              </Grid>
            </Grid>
          </Grid>

          {
            isEditing
              ? <ExistSubEdit
                isEditing={isEditing}
                onDiscardEditMenu={handleDiscardEditMenu}
                onSaveEditMenu={handleSaveEditMenu}
                editExistSubDatetimeFinishValue={editExistSubDatetimeFinishValue}
                editExistSubDatetimeFinish={editExistSubDatetimeFinish}
              /> : null
          }

        </Grid>
      ) : null }
    </div>
  );
  
}

export default React.memo(ExistSubscription);
